import { gql } from '@apollo/client';
import { coupledLineItemsOnInvoiceInPPC, lineItemDetailsForInvoiceInPPC } from './fetch-coupled-line-items-in-ppc';
import { Overage } from './fetch-overage-items';
import { coupledLineItemsOnInvoiceWithOverage } from './fetch-coupled-line-items-with-overage';

export const fetchInvoiceQueryInPPC = gql`
  ${lineItemDetailsForInvoiceInPPC}
  ${coupledLineItemsOnInvoiceInPPC}
  ${Overage}
  ${coupledLineItemsOnInvoiceWithOverage}
  query fetchInvoiceQueryInPPC(
    $id: ID!
    $transactionAccountId: String
    $includeOverage: Boolean = false
    $fetchAddOns: Boolean = false
    $fetchAGPAddon: Boolean = false
  ) {
    invoice(
      id: $id
      transactionAccountId: $transactionAccountId
      fetchAddOns: $fetchAddOns
      fetchAGPAddon: $fetchAGPAddon
    ) {
      id
      invoiceNumber
      sourceId
      selfServeBACInvoiceLink
      invoiceNumber
      domain
      status
      createdTimestamp
      userDefinedNotes
      billingGroupId
      paymentMethodId
      creditCard {
        last4Numbers
        cardHolderName
        expirationMonth
        expirationYear
        brand
      }
      dunningStatus {
        attemptCount
        paymentRetryDate
        errorCode
        declineCode
        nextPaymentAttempDate
      }
      sourceSystem
      upgradeCredits
      totalDiscount
      totalPartnerMargin
      memo
      billTo {
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
        taxIds {
          id
          label
          taxExempt
          metadata {
            vatStatus
          }
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
          }
        }
      }
      shipTo {
        id
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
        taxIds {
          id
          label
          taxExempt
          metadata {
            vatStatus
          }
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
          }
        }
      }
      total
      taxes
      subtotal
      taxes
      taxesPaymentCurrency
      transactionAccountId
      itemsTotal
      partnerAccountId
      partnerName
      paypalAccountEmail
      paymentCurrency
      pricingCurrency
      paymentMethod
      promotionCode
      invoiceDueDays
      dueDate
      purchaseOrderNumber
      lineItems {
        ...lineItemDetailsForInvoiceInPPC
        ...Overage @include(if: $includeOverage)
        orderLineId
      }
      coupledLineItems(fetchAGPAddon: $fetchAGPAddon) {
        ...coupledLineItemsOnInvoiceInPPC @skip(if: $includeOverage)
        ...coupledLineItemsOnInvoiceWithOverage @include(if: $includeOverage)
      }
      dstLineItems {
        ...lineItemDetailsForInvoiceInPPC
        metadata {
          parentItemId
          type
        }
      }
      refunds {
        id
        creditNoteNumber
        currency
        createdDate
        transactionAccountId
        sourceSystem
        memo
        reason
        refundId
        status
        type
        total
        arn
        refundItems {
          id
          invoiceLineItemId
          entitlementId
          quantity
          description
          total
          totalExTax
          totalTax
          taxRate
          taxableAmount
          taxExemptAmount
        }
        requestedBy
      }
      slaCredits {
        amountExTax
        amountIncTax
        createdAt
        creditExternalId
        currency
        currencyExchangeRate
        modifiedAt
        notes
        taxAmount
        taxRate
      }
      pdfLink
      appliedBalance
    }
  }
`;
